namespace Gamification.Gamification {
    export interface ApiScriptClassificheForm {
        IdApi: Serenity.LookupEditor;
        IdProdotto: Serenity.LookupEditor;
        PunteggioGlobale: Serenity.BooleanEditor;
        ExpConLivello: Serenity.BooleanEditor;
        Esperienze: Serenity.LookupEditor;
        Nome: Serenity.StringEditor;
        Limitazione: Serenity.IntegerEditor;
        RelativaUtente: Serenity.BooleanEditor;
        Ordinamento: Serenity.EnumEditor;
    }

    export class ApiScriptClassificheForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ApiScriptClassifiche';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ApiScriptClassificheForm.init)  {
                ApiScriptClassificheForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.EnumEditor;

                Q.initFormType(ApiScriptClassificheForm, [
                    'IdApi', w0,
                    'IdProdotto', w0,
                    'PunteggioGlobale', w1,
                    'ExpConLivello', w1,
                    'Esperienze', w0,
                    'Nome', w2,
                    'Limitazione', w3,
                    'RelativaUtente', w1,
                    'Ordinamento', w4
                ]);
            }
        }
    }
}
